export default __webpack_public_path__ + "static/media/gg.cff3c621.svg";